import React, { useState } from "react";
import { PLATEFORME_ELECTRONIQUE_LOGOS } from "./plateformeElectroniqueOptions";

// Logo de la plateforme électronique ("PA") — si le fichier n'est pas
// (encore) présent dans public/logos-pa/, on retombe sur le nom en texte
// plutôt que sur une icône cassée. Partagé entre Portefeuille.js et
// FicheClientOverlay.js pour ne pas dupliquer cette logique.
function PlateformeLogo({ value, className = "h-5 w-auto max-w-[64px]" }) {
  const [imgError, setImgError] = useState(false);
  if (!value) return null;
  const logoSrc = PLATEFORME_ELECTRONIQUE_LOGOS[value];
  if (!logoSrc || imgError) {
    return <span title={value}>{value}</span>;
  }
  return (
    <img
      src={logoSrc}
      alt={value}
      title={value}
      className={`${className} object-contain inline-block`}
      onError={() => setImgError(true)}
    />
  );
}

export default PlateformeLogo;
